/**
 * Get the document scroll top position
 * @returns {number} amount in px from the top position
 */
export default function scrollTop() {
    return Math.max(0, (window.scrollY || window.pageYOffset || document.documentElement.scrollTop) || 0);
}

export function scrollTopElement(element) {
    return Math.max(0, (element.scrollTop), 0);
}



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/util/dom/scroll-top.js